export default "__VITE_ASSET__CExsGpIk__"